(() => {
  const ROOT_SELECTOR = '[data-liver-pdp]';

  function init(root) {
    if (!root || root.dataset.liverInitialized === 'true') return;
    root.dataset.liverInitialized = 'true';

    const galleryStage = root.querySelector('[data-liver-gallery-stage]');
    const galleryTrack = root.querySelector('[data-liver-gallery-track]');
    const galleryCounts = root.querySelectorAll('[data-liver-gallery-count]');
    const galleryThumbs = root.querySelectorAll('[data-liver-thumb]');
    const galleryTotal = galleryThumbs.length;
    const previousButtons = root.querySelectorAll('[data-liver-prev]');
    const nextButtons = root.querySelectorAll('[data-liver-next]');
    const bundleCards = root.querySelectorAll('[data-liver-bundle]');
    const checkoutButton = root.querySelector('[data-liver-checkout-button]');
    const checkoutLabel = root.querySelector('[data-liver-checkout-label]');
    const checkoutSuffix = root.querySelector('[data-liver-atc-suffix]');
    const checkoutStatus = root.querySelector('[data-liver-checkout-status]');
    const headerCheckout = root.querySelector('[data-liver-header-checkout]');
    const sticky = root.querySelector('[data-liver-sticky]');
    const buySection = root.querySelector('#buy');
    const mechanism = document.querySelector('[data-liver-mechanism]');
    const mechanismSection = mechanism ? (mechanism.closest('.section-absora-liver-mechanism') || document) : document;
    const mechanismStages = mechanismSection.querySelectorAll('[data-liver-stage]');
    const mechanismReplay = mechanismSection.querySelector('[data-liver-replay]');

    const variants = [root.dataset.variantOne, root.dataset.variantThree, root.dataset.variantFive];
    const prices = ['$21.99', '$43.98', '$65.97'];
    let galleryIndex = 0;
    let bundleIndex = 1;
    let dragging = false;
    let dragStartX = 0;
    let dragOffsetX = 0;
    let animationFrame = 0;
    let mechanismTimers = [];
    let mechanismObserver = null;
    let mechanismInterval = 0;
    let mechanismCheck = null;
    let checkoutInProgress = false;

    function resetCheckoutState() {
      checkoutInProgress = false;
      if (checkoutButton) {
        checkoutButton.disabled = false;
        checkoutButton.removeAttribute('aria-busy');
      }
      if (checkoutLabel) checkoutLabel.textContent = 'ADD TO CART';
      if (checkoutSuffix) checkoutSuffix.style.display = '';
      if (headerCheckout) {
        headerCheckout.removeAttribute('aria-busy');
        headerCheckout.textContent = `Cart (${[1, 3, 5][bundleIndex]})`;
      }
      if (checkoutStatus) {
        checkoutStatus.textContent = '';
        checkoutStatus.style.display = 'none';
      }
    }

    function setGallery(index, animate = true) {
      galleryIndex = Math.max(0, Math.min(galleryTotal - 1, index));
      if (galleryTrack) {
        galleryTrack.style.transition = animate ? 'transform 0.35s cubic-bezier(0.22,1,0.36,1)' : 'none';
        galleryTrack.style.transform = `translateX(${-galleryIndex * 100}%)`;
      }
      galleryCounts.forEach((count) => { count.textContent = `${galleryIndex + 1} of ${galleryTotal}`; });
      galleryThumbs.forEach((thumb) => {
        thumb.style.borderColor = Number(thumb.dataset.liverThumb) === galleryIndex ? '#1C4532' : 'transparent';
        thumb.setAttribute('aria-current', Number(thumb.dataset.liverThumb) === galleryIndex ? 'true' : 'false');
      });
      previousButtons.forEach((button) => {
        button.style.opacity = galleryIndex === 0 ? '0.35' : '1';
        button.disabled = galleryIndex === 0;
      });
      nextButtons.forEach((button) => {
        button.style.opacity = galleryIndex === galleryTotal - 1 ? '0.35' : '1';
        button.disabled = galleryIndex === galleryTotal - 1;
      });
    }

    function selectBundle(index) {
      bundleIndex = Math.max(0, Math.min(2, index));
      bundleCards.forEach((card) => {
        const selected = Number(card.dataset.liverBundle) === bundleIndex;
        card.classList.toggle('is-selected', selected);
        card.setAttribute('aria-pressed', selected ? 'true' : 'false');
        const ring = card.querySelector('[data-liver-selection-ring]');
        const dot = card.querySelector('[data-liver-selection-dot]');
        if (ring) ring.style.display = selected ? 'block' : 'none';
        if (dot) dot.style.display = selected ? 'block' : 'none';
      });
      if (checkoutButton) {
        checkoutButton.dataset.checkoutPermalink = `/cart/${variants[bundleIndex]}:1?checkout`;
      }
      if (headerCheckout) {
        headerCheckout.href = `/cart/${variants[bundleIndex]}:1?checkout`;
        headerCheckout.textContent = `Cart (${[1, 3, 5][bundleIndex]})`;
        headerCheckout.setAttribute('aria-label', `Checkout with ${[1, 3, 5][bundleIndex]} bottle${bundleIndex === 0 ? '' : 's'}`);
      }
      if (checkoutSuffix) checkoutSuffix.textContent = ` — ${prices[bundleIndex]}`;
      if (checkoutStatus) {
        checkoutStatus.textContent = '';
        checkoutStatus.style.display = 'none';
      }
    }

    async function goToSelectedCheckout(event) {
      if (event) event.preventDefault();
      if (checkoutInProgress) return;

      const variantId = Number(variants[bundleIndex]);
      if (!variantId) return;

      checkoutInProgress = true;
      if (checkoutButton) {
        checkoutButton.disabled = true;
        checkoutButton.setAttribute('aria-busy', 'true');
      }
      if (checkoutLabel) checkoutLabel.textContent = 'PREPARING CHECKOUT';
      if (checkoutSuffix) checkoutSuffix.style.display = 'none';
      if (headerCheckout) {
        headerCheckout.setAttribute('aria-busy', 'true');
        headerCheckout.textContent = 'Loading';
      }
      if (checkoutStatus) {
        checkoutStatus.textContent = '';
        checkoutStatus.style.display = 'none';
      }

      const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      try {
        const clearResponse = await fetch(`${rootPath}cart/clear.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });
        if (!clearResponse.ok) throw new Error('We could not prepare your cart. Please try again.');

        const addResponse = await fetch(`${rootPath}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });
        const addResult = await addResponse.json().catch(() => ({}));
        if (!addResponse.ok) {
          throw new Error(addResult.description || addResult.message || 'This bundle is currently unavailable.');
        }

        window.location.assign(`${rootPath}checkout`);
      } catch (error) {
        resetCheckoutState();
        if (checkoutStatus) {
          checkoutStatus.textContent = error.message || 'This bundle is currently unavailable.';
          checkoutStatus.style.display = 'block';
        }
      }
    }

    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => setGallery(Number(thumb.dataset.liverThumb)));
    });
    previousButtons.forEach((button) => {
      button.addEventListener('pointerdown', (event) => event.stopPropagation());
      button.addEventListener('click', () => setGallery(galleryIndex - 1));
    });
    nextButtons.forEach((button) => {
      button.addEventListener('pointerdown', (event) => event.stopPropagation());
      button.addEventListener('click', () => setGallery(galleryIndex + 1));
    });

    if (galleryStage && galleryTrack) {
      galleryStage.addEventListener('pointerdown', (event) => {
        dragging = true;
        dragStartX = event.clientX;
        dragOffsetX = 0;
        galleryStage.style.cursor = 'grabbing';
        galleryTrack.style.transition = 'none';
        if (galleryStage.setPointerCapture) galleryStage.setPointerCapture(event.pointerId);
      });
      galleryStage.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        dragOffsetX = event.clientX - dragStartX;
        galleryTrack.style.transform = `translateX(calc(${-galleryIndex * 100}% + ${dragOffsetX}px))`;
      });
      const finishDrag = (event) => {
        if (!dragging) return;
        dragging = false;
        galleryStage.style.cursor = 'grab';
        if (dragOffsetX < -60) setGallery(galleryIndex + 1);
        else if (dragOffsetX > 60) setGallery(galleryIndex - 1);
        else if (Math.abs(dragOffsetX) < 8) {
          const rect = galleryStage.getBoundingClientRect();
          setGallery(event.clientX < rect.left + rect.width / 2 ? galleryIndex - 1 : galleryIndex + 1);
        } else setGallery(galleryIndex);
        dragOffsetX = 0;
      };
      galleryStage.addEventListener('pointerup', finishDrag);
      galleryStage.addEventListener('pointercancel', finishDrag);
    }

    bundleCards.forEach((card) => {
      const choose = () => selectBundle(Number(card.dataset.liverBundle));
      card.addEventListener('click', choose);
      card.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          choose();
        }
      });
    });

    if (checkoutButton) checkoutButton.addEventListener('click', goToSelectedCheckout);
    if (headerCheckout) headerCheckout.addEventListener('click', goToSelectedCheckout);
    window.addEventListener('pagehide', resetCheckoutState);
    window.addEventListener('pageshow', resetCheckoutState);

    function updateSticky() {
      if (!sticky || !buySection) return;
      const threshold = buySection.offsetTop + buySection.offsetHeight - 80;
      sticky.hidden = window.scrollY <= threshold;
    }
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    updateSticky();

    function clearMechanismTimers() {
      mechanismTimers.forEach((timer) => window.clearTimeout(timer));
      mechanismTimers = [];
      window.cancelAnimationFrame(animationFrame);
      animationFrame = 0;
    }

    function setMechanismBeat(beat) {
      mechanismStages.forEach((stage, index) => {
        stage.classList.toggle('is-active', index < beat);
      });
    }

    function resetMechanism() {
      if (!mechanism) return;
      clearMechanismTimers();
      mechanism.removeAttribute('data-lv-active');
      mechanism.removeAttribute('data-lv-rm');
      mechanism.querySelectorAll('[data-lv-rest]').forEach((particle) => {
        particle.style.offsetDistance = '';
        particle.style.opacity = '';
      });
      const counter = mechanism.querySelector('[data-lv-count]');
      if (counter) counter.textContent = '80';
      setMechanismBeat(0);
      mechanism.setAttribute('data-lv-reset', '');
      void mechanism.offsetWidth;
      mechanism.removeAttribute('data-lv-reset');
    }

    function startMechanism(force = false) {
      if (!mechanism || (!force && mechanism.dataset.liverStarted === 'true')) return;
      mechanism.dataset.liverStarted = 'true';
      clearMechanismTimers();
      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const counter = mechanism.querySelector('[data-lv-count]');
      if (reduceMotion) {
        mechanism.setAttribute('data-lv-rm', '');
        mechanism.querySelectorAll('[data-lv-rest]').forEach((particle) => {
          particle.style.offsetDistance = particle.getAttribute('data-lv-rest') || '60%';
          particle.style.opacity = '1';
        });
        if (counter) counter.textContent = '80';
        setMechanismBeat(3);
        return;
      }
      mechanism.setAttribute('data-lv-active', '');
      setMechanismBeat(1);
      mechanismTimers.push(window.setTimeout(() => setMechanismBeat(2), 2500));
      mechanismTimers.push(window.setTimeout(() => setMechanismBeat(3), 5600));
      if (!counter) return;
      counter.textContent = '0';
      mechanismTimers.push(window.setTimeout(() => {
        const start = performance.now();
        const duration = 900;
        const step = (now) => {
          const progress = Math.min(1, (now - start) / duration);
          counter.textContent = String(Math.round((1 - Math.pow(1 - progress, 3)) * 80));
          if (progress < 1) animationFrame = requestAnimationFrame(step);
        };
        animationFrame = requestAnimationFrame(step);
      }, 700));
    }

    function stopMechanismWatch() {
      if (mechanismObserver) mechanismObserver.disconnect();
      mechanismObserver = null;
      if (mechanismCheck) window.removeEventListener('scroll', mechanismCheck);
      if (mechanismInterval) window.clearInterval(mechanismInterval);
      mechanismInterval = 0;
    }

    function mechanismIsVisible() {
      if (!mechanism) return false;
      const rect = mechanism.getBoundingClientRect();
      const viewportHeight = window.innerHeight || 800;
      const visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
      return visibleHeight > Math.min(rect.height, viewportHeight) * 0.25;
    }

    function triggerMechanism() {
      if (!mechanism || mechanism.dataset.liverStarted === 'true') return;
      stopMechanismWatch();
      startMechanism();
    }

    if (mechanism) {
      mechanismCheck = () => { if (mechanismIsVisible()) triggerMechanism(); };
      if ('IntersectionObserver' in window) {
        mechanismObserver = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) triggerMechanism();
        }, { threshold: 0.25 });
        mechanismObserver.observe(mechanism);
        window.addEventListener('scroll', mechanismCheck, { passive: true });
        mechanismInterval = window.setInterval(mechanismCheck, 400);
        mechanismCheck();
      } else startMechanism();
    }

    if (mechanismReplay) {
      mechanismReplay.addEventListener('click', () => {
        stopMechanismWatch();
        resetMechanism();
        startMechanism(true);
      });
    }

    root.addEventListener('shopify:section:unload', () => {
      window.removeEventListener('scroll', updateSticky);
      window.removeEventListener('resize', updateSticky);
      window.removeEventListener('pagehide', resetCheckoutState);
      window.removeEventListener('pageshow', resetCheckoutState);
      stopMechanismWatch();
      clearMechanismTimers();
    }, { once: true });

    setGallery(0, false);
    selectBundle(1);
  }

  function initAll(scope = document) {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
